module.exports = __webpack_public_path__ + "static/media/delete-readiness.6357627e.svg";